import MicroModal from 'micromodal';

export const openModal = (modalTarget) => {
  return () => {
    MicroModal.show(modalTarget.dataset.modalId, { disableScroll: true });
    modalTarget.src = ''; // Prevent the profile from reopening when you navigate away, then use the browser's Back link: https://discuss.hotwired.dev/t/way-to-prevent-history-update/3577
  };
};
